<template>
  <div>
    <el-tag
        :key="tag"
        v-for="tag in dynamicTags"
        closable
        :disable-transitions="false"
        @close="handleClose(tag)">
        {{tag}}
    </el-tag>
    <el-input
        class="input-new-tag"
        v-if="inputVisible"
        v-model="inputValue"
        ref="saveTagInput"
        size="small"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
    >
    </el-input>
    <el-button v-else class="button-new-tag" size="small" @click="showInput">
        +新标签
    </el-button>
    
    <div class="selectable-area">
        <el-tag
            round
            :key="tag"
            closable
            type="info"
            hit
            size="mini"
            v-for="(tag,idx) in tagOptions"
            @close="handleDelete(tag)"
            @click="onOptionClick(tag)">
            {{tag}}({{tagOptionNumbers[idx]}})
        </el-tag>
    </div>
  </div>
</template>


<style <style lang="scss" scoped>

  .selectable-area {
      background-color: #eeeeee;
  }
  .el-tag {
    cursor: pointer;
  }
  
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 20px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: middle;
  }
</style>

<script>
import tagApi from '../models/tag'

export default {
  props: {
    defaultSelection: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      tagOptions: [],
      tagOptionNumbers: [],
      dynamicTags: this.defaultSelection,
      inputVisible: false,
      inputValue: '',
    }
  },
  methods: {
    onOptionClick(tag) {
      if (this.dynamicTags.indexOf(tag) < 0) {
        this.dynamicTags.push(tag)
      }
    },

    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },

    handleDelete(tag) {
      this.$confirm('此操作将永久删除该标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await tagApi.deleteByName(tag)
        this.$message({
          type: res.error_code === 0 ? 'success' : 'error',
          message: res.msg,
        })

        if (res.error_code === 0) {
          this.tagOptions.splice(this.tagOptions.indexOf(tag), 1)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      const val = this.inputValue
      if (val) {
        this.dynamicTags.push(val)
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    async updateTags() {
      const tags = await tagApi.getTags()
      this.tagOptions = []
      this.tagOptionNumbers = []
      for (const i in tags) {
        this.tagOptions.push(tags[i].name)
        this.tagOptionNumbers.push(tags[i].count)
      }
    },
  },
  watch: {
    defaultSelection(newValue) {
      this.dynamicTags = newValue
    },
    dynamicTags(newValue) {
      this.$emit('input', newValue)
    },
  },
  async mounted() {
    await this.updateTags()
  },
}
</script>
